import LogoLoginMobileSvg from 'src/assets/images/logo-login-mobile.svg';
import styled from 'styled-components';

export const LogoLoginMobile = styled(LogoLoginMobileSvg)`
  height: 1.875rem;
`;
